import { useSeats } from '../../hooks/useSeats';
import React, { FC, useMemo } from 'react';
import {
  TransferOwnersModal,
  TransferOwnersModalProps,
} from '../../components/TransferOwnersModal';
import { Role } from '@fullstory/proto/fs/services/orgs';

type TransferOwnersModalContainerProps =
  | { ownerEmails: string[] } & Omit<TransferOwnersModalProps, 'users'> &
      Omit<TransferOwnersModalProps, 'owners'>;

export const TransferOwnersModalContainer: FC<TransferOwnersModalContainerProps> = ({
  ownerEmails,
  ...props
}) => {
  const seats = useSeats();
  const users = useMemo(() => {
    if (seats) {
      const formattedSeats = seats.entities
        ?.filter(entity => entity.seat)
        .map(val => {
          const email = val.seat?.id?.email;
          return {
            email: email ?? '',
            firstName: val.seat?.firstName ?? '',
            lastName: val.seat?.lastName ?? '',
            role: val.seat?.role ?? Role.UNKNOWN,
          };
        });
      return formattedSeats;
    }
    return [];
  }, [seats]);

  const owners = useMemo(() => {
    if (seats) {
      const formattedSeats = seats.entities
        ?.filter(entity => entity.seat)
        .filter(entity => ownerEmails.includes(entity.seat?.id?.email!))
        .map(val => {
          const email = val.seat?.id?.email;
          return {
            email: email ?? '',
            firstName: val.seat?.firstName ?? '',
            lastName: val.seat?.lastName ?? '',
          };
        });
      return formattedSeats;
    }
    return [];
  }, [ownerEmails, seats]);

  return (
    <TransferOwnersModal
      data-component="TransferOwnerModalContainer"
      users={users}
      owners={owners}
      {...props}
    />
  );
};
